<template>
    <div id="app">
        <router-view/>
        <!--完善用户信息-->
        <ImproveProfile/>
      <!--用户认证-->
      <UserVerify
        :visible.sync="verifyVisible"
        :default-type="defaultVerifyType"
        @submitted="handleVerifySubmitted"
      />
    </div>
</template>

<script>
    import store from "../src/vuex/store";
    import ImproveProfile from "./components/_widget/ImproveProfile.vue";
    import UserVerify from "./components/auth/UserVerify.vue";
    export default {
        name: "app",
        data(){
            return {
                done:false,
                verifyVisible: false,
                needVerifyRoute: null,
              defaultVerifyType: 'company'
            }
        },
        watch: {
            $route(v) {
                this.loadProfile(false);
              // 只在访问 /own/publish 时检查认证
              if (v.path === '/own/publish') {
                this.checkPublishVerify();
              }
            }
        },
        created(){
            this.loadShake();

            //双11活动
            this.shiyi();
            //cart

            this.$event_bus.$on("woaCartLoad", () => {
                this.loadCart('woa');
            });
            this.$event_bus.$on("weiboCartLoad", () => {
                this.loadCart('weibo');
            });
            this.$event_bus.$on("liveCartLoad", () => {
                this.loadCart('live');
            });

            this.$event_bus.$on("newsCartLoad", () => {
                this.loadCart('news');
            });

            this.$event_bus.$on("videoCartLoad", () => {
                this.loadCart('video');
            });

            this.$event_bus.$on("xhsCartLoad", () => {
                this.loadCart('xhs');
            });

            //首次加载购物车
            this.loadCart(this.$store.state.cartTaxonomy);

          // 初始化时检查当前路由是否需要认证
          this.$nextTick(() => {
            this.checkVerifyRequirement(this.$route);
          });
        },
        store,
        methods: {
            loadProfile(loading) {
                let loadingInstance = loading && this.$loading();
                this.$http
                    .get("/personal/profile")
                    .then(response => {
                        this.$store.commit("changeAuth", {
                            isLogin: !!response.success,
                            isDone:true
                        });

                        this.$store.commit("changeProfile", response.success ? response.data : this.$store.state._profile);
                        this.done = response.success;
                        if (response.success) {
                          this.redirectIfNeedBindWechat(response.data);
                        }
                      // 检查是否需要显示认证弹窗
                      if (response.success && this.needVerifyRoute) {
                        this.checkAndShowVerify(response.data);
                      }
                        /*if(response.success && process.env.NODE_ENV === 'production')
                        {
                            //判断agency.site
                            if(response.data.agency.site)
                            {
                                if(response.data.agency.site!=window.location.host)
                                {
                                    window.location.href='http://'+response.data.agency.site
                                }
                            }
                        }*/
                    })
                    .catch(res => {
                    })
                    .then(response => {
                        this.$nextTick(() => {
                            loading && loadingInstance.close();
                        });
                    });
            },
          handleVerifySubmitted() {
            // 认证提交后，刷新用户信息
            this.loadProfile(false);
            this.needVerifyRoute = null;
          },
          // 检查路由是否需要认证
          checkVerifyRequirement(to) {
            const meta = to.meta || {};
            const requireVerify = meta.verify === true;

            if (requireVerify && this.done) {
              const profile = this.$store.state.profile;
              const isVerified = profile.verify === 1 || profile.verify_status === 1;

              if (!isVerified) {
                this.needVerifyRoute = to;
                this.defaultVerifyType = 'company';
                this.verifyVisible = true;
                return false;
              }
            }
            return true;
          },
          // 媒体用户未绑定公众号时，跳到添加资源页并提醒
          redirectIfNeedBindWechat(profile) {
            if (!profile || Number(profile.is_media) !== 1) {
              return
            }
            const openid = profile.openid && profile.openid.openid
            if (openid !== undefined && openid !== null && String(openid).trim() !== '') {
              return
            }
            const path = (this.$route && this.$route.path) || ''
            if (path.indexOf('/login') === 0 || path.indexOf('/signup') === 0 || path.indexOf('/retrievepwd') === 0 || path.indexOf('/manuscripts/') === 0) {
              return
            }
            const target = '/own/personal/resource_add'
            // 媒体栏目页由路由守卫提示并跳转，避免重复提醒
            const mediaPages = [
              target,
              '/own/personal/resource_list',
              '/own/personal/manager_resource',
              '/own/personal/own_order',
              '/own/personal/own_income',
              '/own/personal/withdraw_list'
            ]
            if (mediaPages.indexOf(path) !== -1) {
              return
            }
            this.$message.warning('点击绑定公众号，扫码绑定，实时接收订单消息！')
            this.$router.push(target).catch(() => {})
          },
          // 检查文章发布页面的认证
          checkPublishVerify() {
            if (this.done) {
              const profile = this.$store.state.profile;
              const isVerified = profile.verify === 1 || profile.verify_status === 1;

              // 2026 年 3 月 16 日 00:00:00 的 Unix 时间戳
              const targetTimestamp = 1773590400;

              // 判断用户注册时间是否在 2026 年 3 月 16 日之后
              const isNewUser = profile.created_at && profile.created_at >= targetTimestamp;

              if (!isVerified && isNewUser) {
                // 直接跳转到认证页面
                this.$router.push('/own/personal/verify');

                // 延迟弹出认证弹窗
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.verifyVisible = true;
                  }, 300);
                });
              } else if (!isVerified && !isNewUser) {
                // 老用户未认证：保持原有逻辑（不强制认证）
                // 可以在这里添加老用户的提示或其他处理
                console.log('老用户未认证，允许继续操作');
              }
            }
          },
            //检测用户在线状态
            loadShake()
            {
                this.$http
                    .get("/auth/shake?t="+(+new Date))
                    .then(response => {
                    }).catch().then(()=>{
                        setTimeout(()=>{
                            this.loadShake()
                        },30000)
                    })
            },
            shiyi(){
              var url = window.location.href;
              if(url.indexOf("manuscripts") >= 0 ||
                url.indexOf("login") >= 0 ||
                url.indexOf("signup") >= 0 ||
                url.indexOf("retrievepwd") >= 0){

              }else{
                this.$http
                  .get("/personal/profile")
                  .then(response => {

                    this.$store.commit("changeAuth", {
                      isLogin: !!response.success,
                      isDone:true
                    });

                    this.$store.commit("changeProfile", response.success ? response.data : this.$store.state._profile);

                    this.done = response.success

                    if(response.success)
                    {
                      console.log(response.data.id);
                      this.redirectIfNeedBindWechat(response.data);
                        /*if(response.data.id !== 317627){
                          this.$alert('活动时间：2019年10月11日00:00-2019年11月11日24:00。以实际充值时间为准。详询销售顾问。', '双十一钜惠狂欢', {
                            type: '',
                            confirmButtonText: '确定'
                          }).then(()=>{
                            setTimeout(()=>{
                              this.shiyi()
                            },12000000)
                          });
                        }*/
                    }else{
                      /*this.$alert('活动时间：2019年10月11日00:00-2019年11月11日24:00。以实际充值时间为准。详询销售顾问。', '双十一钜惠狂欢', {
                        type: '',
                        confirmButtonText: '确定'
                      }).then(()=>{
                        setTimeout(()=>{
                          this.shiyi()
                        },12000000)
                      });*/
                    }
                  })
              }
            },
            loadCart(taxonomy){

                this.$store.commit('changeCartLoading',true)

                this.$http
                    .get(`/cart?taxonomy=${taxonomy}`)
                    .then(response => {
                        if (response.success) {

                            this.$store.commit('changeCartSource',{taxonomy:taxonomy,dataSource:response.data})
                            // this.dataSource = response.data;

                            // this.length[this._taxonomy] = this.dataSource.length;

                            // this.money = 0;
                            // this.dataSource.forEach(element => {
                            //     this.money += parseInt(element.price);
                            // });
                            // this.money = this.money.toFixed(2);
                        }
                    })
                    .catch()
                    .then(() => {
                        this.$store.commit('changeCartLoading',false)
                    });
            },
        },
        components: {
            ImproveProfile,
            UserVerify
        }
    };

</script>



// WEBPACK FOOTER //
// src/App.vue